import(/* webpackMode: "eager" */ "/cftest/app/global-error.tsx");
